import { useEffect } from "react";
import { fetchPageBreaks } from "../../api/features/pagebreaks/actions";
import { useSelector } from "react-redux";
import {
  getPageBreaks,
  getPageBreaksLoadStatus,
} from "../../api/features/pagebreaks/selectors";
import { useAppDispatch } from "../../api/core/useAppDispatch";
import { DetailedLoadStatus } from "../../../../../common/utils/async-status";
import { findPageLabelFromCfi } from "../../../../../common/utils/cfi";

export default function usePageBreaks() {
  const loadStatus = useSelector(getPageBreaksLoadStatus);
  const dispatch = useAppDispatch();
  const pageBreaks = useSelector(getPageBreaks);

  useEffect(() => {
    if (loadStatus === DetailedLoadStatus.WAITING) {
      dispatch(fetchPageBreaks());
    }
  }, [dispatch, loadStatus]);

  const cfiToPage = (cfi: string) => {
    return findPageLabelFromCfi(pageBreaks, cfi);
  };

  return {
    loadStatus,
    cfiToPage,
    // TODO: Return page breaks, if ever needed
  };
}
